module.exports = __webpack_public_path__ + "static/media/info.da8b6b4a.svg";